import { TableColumnMeta } from "ds/components/Table/types";

import { FilterItemKeys } from "../constants";

export const POLICIES_TABLE_STORAGE_KEY = "policiesListTable";

export enum POLICIES_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  LABELS = "LABELS",
  TYPE = "TYPE",
  SPACE = "SPACE",
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const POLICIES_TABLE_COLUMNS_CONFIG: Record<POLICIES_COLUMN_ID, TableColumnMeta> = {
  [POLICIES_COLUMN_ID.NAME]: {
    id: POLICIES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [POLICIES_COLUMN_ID.DESCRIPTION]: {
    id: POLICIES_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 120,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [POLICIES_COLUMN_ID.LABELS]: {
    id: POLICIES_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 100,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [POLICIES_COLUMN_ID.TYPE]: {
    id: POLICIES_COLUMN_ID.TYPE,
    title: "Type",
    minWidth: 80,
    defaultWidth: 120,
    maxWidth: 200,
    resizable: false,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [POLICIES_COLUMN_ID.SPACE]: {
    id: POLICIES_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [POLICIES_COLUMN_ID.CREATED_AT]: {
    id: POLICIES_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 120,
    defaultWidth: 180,
    maxWidth: 240,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [POLICIES_COLUMN_ID.UPDATED_AT]: {
    id: POLICIES_COLUMN_ID.UPDATED_AT,
    title: "Last update",
    minWidth: 120,
    defaultWidth: 180,
    maxWidth: 240,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [POLICIES_COLUMN_ID.DROPDOWN]: {
    id: POLICIES_COLUMN_ID.DROPDOWN,
    title: "Policy actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    allowsSorting: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

export const POLICIES_SORT_CONFIG: Partial<Record<POLICIES_COLUMN_ID, string>> = {
  [POLICIES_COLUMN_ID.NAME]: FilterItemKeys.NAME,
  [POLICIES_COLUMN_ID.TYPE]: FilterItemKeys.TYPE,
  [POLICIES_COLUMN_ID.SPACE]: FilterItemKeys.SPACE,
  [POLICIES_COLUMN_ID.CREATED_AT]: FilterItemKeys.CREATED_AT,
  [POLICIES_COLUMN_ID.UPDATED_AT]: FilterItemKeys.UPDATED_AT,
};
